import type { MarketApi } from '@/api/generated-api'

type ApiClient = MarketApi<unknown>['api']

let apiPromise: Promise<ApiClient> | null = null

export function loadApiClient(): Promise<ApiClient> {
  if (!apiPromise) {
    apiPromise = import('@/api/client').then(mod => mod.default)
  }
  return apiPromise
}
